<template>
    <div class="item" @click="onPressNav('articleDetail', {id: item.id})">
        <div>
            <p class="title">{{item.name}}</p>
            <span class="time">发布:{{item.create_time}}</span>
            <div>
                <div>
                    <img :src="Images.icon_read" alt="">
                    <p>{{item.visits}}</p>
                </div>
                <div>
                    <img :src="Images.icon_zan_blue" alt="">
                    <p>{{item.likes}}</p>
                </div>
                 <div>
                    <img :src="Images.icon_share_blue" alt="">
                    <p>{{item.shares}}</p>
                </div>
            </div>
        </div>
        <img :src="item.cover" alt="">
    </div>
</template>
<script>
export default {
    name: "articleItem",
    props:['item'],
    data() {
        return {
            
        };
    },
    methods: {
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
    },
};
</script>
<style lang="less" scoped>
.item {
    margin: 10px 15px;
    padding: 10px;
    background: #fff;
    display: flex;

    > div {
        // flex: 1;
        width: calc(100% - 125px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
            font-size: 14px;
            color: #333;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .time {
            font-size: 13px;
            color: #666;
        }

        > div {
            display: flex;
            align-items: center;

            > div {
                flex: 1;
                display: flex;
                align-items: center;

                img {
                    width: 15px;
                    height: 15px;
                    object-fit: contain;
                    margin-right: 5px;
                }

                p {
                    font-size: 13px;
                    color: #333;
                }
            }
        }
    }

    > img {
        width: 115px;
        height: 74px;
        object-fit: cover;
        margin-left: 10px;
    }
}
</style>